import {Fragment, useRef, useState} from 'react';
import React from "react";
import ListEdit from "../UI/ListEdit";
import Box from "../UI/Box";
import {useNavigate} from "react-router-dom";
import {useCustomerFilters} from "../../hooks/useCustomerFilters";

const CustomerFilterList = (props) => {
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const fromDateFilterRef = useRef(null);
    const [filterFromDate, setFilterFromDate] = useState((new Date()).toISOString().slice(0, 10) + 'T00:00');
    const {customerFilters, pagination} = useCustomerFilters(page, pageSize, filterFromDate, 0);
    const navigate = useNavigate();

    const handlePageChange = (pageNumber) => {
        setPage(pageNumber);
    };

    const handlePageSizeChange = (pageSize) => {
        setPageSize(pageSize);
        setPage(1);
    };

    const handleShowIconClick = (customerFilterId) => {
        navigate('/customer-filters/' + customerFilterId + '/customers');
    }

    const handleFromDateFilterChange = () => {
        setFilterFromDate(fromDateFilterRef.current.value)
        setPage(1);
    }

    const listHeaders = [
        'Id',
        'Name',
        'Customer Count',
        'Actions'
    ];

    const columns = {
        functionParams : ['customerFilterId'],
        dataKeys       : [
            'customerFilterId',
            'name',
            'customerCount',
        ],
    }

    return <Fragment>
        <Box>
            <div className="flex my-4">
                <input ref={fromDateFilterRef} defaultValue={filterFromDate} type="datetime-local" placeholder="Filter by from date" className="border p-2 mr-2" onChange={handleFromDateFilterChange}/>
            </div>
            <ListEdit
                headers={listHeaders}
                items={customerFilters}
                columns={columns}
                pagination={pagination}
                handleShowIconClick={handleShowIconClick}
                handlePageChange={handlePageChange}
                handlePageSizeChange={handlePageSizeChange}
            />
        </Box>
    </Fragment>;
}

export default CustomerFilterList;